<div id="forgot">

<div style="text-align: center;">
    <h1 class="header">New Password</h1>
    
    <div class="container" style="text-align: center;" >
      <div class="row">
        <div style="text-align: center;">
         
          <form  #f="ngForm" [formGroup]="forgotPasswordForm" style="margin-right: auto;margin-left: auto;" >
           
            <div class="form-group" >
                <label>Email address</label>
                <input type="email" formControlName="email" class="form-control" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" required>
                <p class="errorText" style="color: red;" *ngIf="!forgotPasswordForm.controls.email.valid && forgotPasswordForm.controls.email.touched">
                  Email is required
                </p>
              </div>
             
              <p>{{resetStatus}}</p>
           
              <button type="submit" [disabled]="!f.valid" style="width: 200px;" (click)="resetPassword(forgotPasswordForm.value.email)" class="btn btn-info">Reset Password</button>
         
            </form>
        </div>
      </div>
      
      <div class="row">
        <div>
          <p>Go back to - <a [routerLink]="['/login']">Login</a></p>
        </div>
      </div>
    </div>
    </div>

  </div>